"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
var _framerMotion = require("framer-motion");
var _excluded = ["isOpen", "isCollapse", "children", "screenSide", "animationWidth", "animationMinWidth", "overlay", "heightMin", "heightMax", "transparent", "borderRadiusClosed", "marginTop", "animationDuration"],
  _excluded2 = ["isCollapse", "children", "screenSide", "animationWidth", "animationMinWidth", "overlay", "heightMin", "heightMax", "transparent", "borderRadiusClosed", "marginTop", "animationDuration"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Drawer = exports.Drawer = function Drawer(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
    isCollapse = _ref.isCollapse,
    children = _ref.children,
    screenSide = _ref.screenSide,
    animationWidth = _ref.animationWidth,
    animationMinWidth = _ref.animationMinWidth,
    overlay = _ref.overlay,
    heightMin = _ref.heightMin,
    heightMax = _ref.heightMax,
    transparent = _ref.transparent,
    borderRadiusClosed = _ref.borderRadiusClosed,
    marginTop = _ref.marginTop,
    animationDuration = _ref.animationDuration,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, isOpen && /*#__PURE__*/_react["default"].createElement(DrawerMotion, _extends({
    screenSide: screenSide,
    animationWidth: animationWidth,
    animationMinWidth: animationMinWidth,
    overlay: overlay,
    isCollapse: isCollapse,
    heightMin: heightMin,
    heightMax: heightMax,
    transparent: transparent,
    borderRadiusClosed: borderRadiusClosed,
    marginTop: marginTop,
    animationDuration: animationDuration
  }, props), children));
};
var DrawerMotion = function DrawerMotion(_ref2) {
  var isCollapse = _ref2.isCollapse,
    children = _ref2.children,
    screenSide = _ref2.screenSide,
    _ref2$animationWidth = _ref2.animationWidth,
    animationWidth = _ref2$animationWidth === void 0 ? 1000 : _ref2$animationWidth,
    _ref2$animationMinWid = _ref2.animationMinWidth,
    animationMinWidth = _ref2$animationMinWid === void 0 ? 82 : _ref2$animationMinWid,
    overlay = _ref2.overlay,
    heightMin = _ref2.heightMin,
    _ref2$heightMax = _ref2.heightMax,
    heightMax = _ref2$heightMax === void 0 ? '100%' : _ref2$heightMax,
    transparent = _ref2.transparent,
    borderRadiusClosed = _ref2.borderRadiusClosed,
    marginTop = _ref2.marginTop,
    _ref2$animationDurati = _ref2.animationDuration,
    animationDuration = _ref2$animationDurati === void 0 ? 0.5 : _ref2$animationDurati,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var variantsOverlay = {
    open: {
      opacity: 1
    },
    closed: {
      opacity: 0,
      transition: {
        delay: 0.3
      }
    }
  };
  var variantsDrawer = {
    open: {
      x: 0
    },
    closed: {
      x: 1000
    }
  };
  var variantsDrawerMenu = {
    open: {
      width: animationWidth
    },
    closed: {
      width: animationMinWidth
    }
  };
  var variantsDrawerTransparent = {
    open: {
      width: animationWidth,
      backgroundColor: ['hsla(255, 255, 255, 1)', 'hsla(255, 255, 255, 0)'],
      height: heightMax,
      boxShadow: ' 0px 2px 2px rgba(0, 0, 0, 0)',
      top: marginTop
    },
    closed: {
      width: animationMinWidth,
      backgroundColor: ['hsla(255, 255, 255, 0)', 'hsla(255, 255, 255, 1)'],
      height: heightMin,
      boxShadow: ' 0px 2px 2px rgba(0, 0, 0, 0.05)',
      borderRadius: borderRadiusClosed,
      top: marginTop
    }
  };
  var drawerOverlayInitial = {
    backgroundColor: 'rgba(4, 4, 4, 0.79)',
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: 101
  };
  var drawerContentInitial = {
    backgroundColor: 'white',
    position: 'absolute',
    height: '100%',
    maxWidth: '100%',
    minWidth: '0px',
    width: animationWidth,
    boxShadow: 'none',
    overflowY: 'auto',
    padding: '10px'
  };
  var drawerMenuContentInitial = {
    backgroundColor: transparent ? 'hsla(255, 255, 255, 1)' : 'white',
    top: 0,
    height: '100%',
    maxWidth: '100%',
    width: animationWidth,
    overflowY: 'auto',
    padding: '10px',
    overflow: 'visible',
    zIndex: 100
  };
  drawerContentInitial[screenSide] = 0;
  if (screenSide === 'left') {
    drawerContentInitial.x = animationWidth * -1;
    variantsDrawer.closed.x = animationWidth * -1;
    drawerMenuContentInitial.left = 0;
    drawerMenuContentInitial.position = 'relative';
    drawerMenuContentInitial.boxShadow = '5px 0 5px -5px rgba(0, 0, 0, 0.15)';
  } else {
    drawerContentInitial.x = animationWidth;
    variantsDrawer.closed.x = animationWidth;
    drawerMenuContentInitial.right = 0;
    drawerMenuContentInitial.position = 'absolute';
    drawerMenuContentInitial.boxShadow = '0px 5px 5px rgba(0, 0, 0, 0.05)';
  }
  if (overlay) {
    return /*#__PURE__*/_react["default"].createElement(_framerMotion.motion.div, {
      key: "drawerOverlay",
      variants: variantsOverlay,
      initial: drawerOverlayInitial,
      animate: "open",
      exit: "closed"
    }, /*#__PURE__*/_react["default"].createElement(_framerMotion.motion.div, {
      key: "drawerContent",
      variants: variantsDrawer,
      initial: drawerContentInitial,
      exit: "closed",
      transition: {
        duration: animationDuration
      }
    }, children));
  } else {
    return /*#__PURE__*/_react["default"].createElement(_framerMotion.motion.div, {
      key: "drawerContent",
      variants: transparent ? variantsDrawerTransparent : variantsDrawerMenu,
      initial: drawerMenuContentInitial,
      animate: isCollapse ? 'open' : 'closed',
      transition: {
        duration: animationDuration
      }
    }, children);
  }
};
var DrawerHeader = function DrawerHeader(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Flex, _extends({}, props, {
    __css: {
      mb: '15px',
      alignItems: 'center',
      flexDirection: 'row-reverse',
      justifyContent: 'space-between'
    }
  }));
};
var DrawerBody = function DrawerBody(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Box, props);
};
var DrawerFooter = function DrawerFooter(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Flex, _extends({}, props, {
    sx: {
      mt: '15px'
    }
  }));
};
Drawer.Header = DrawerHeader;
Drawer.Body = DrawerBody;
Drawer.Footer = DrawerFooter;